<template>
  <div :id="`${file.code}-editor`" class="editor"></div>
</template>

<script>
import * as monaco from "monaco-editor";
import { fromMonaco } from "@sagarjain0907/firepad";

export default {
  props: {
    file: Object,
    firebaseUid: String,
    userColor: String,
    readOnly: Boolean
  },
  data() {
    return {
      editor: null,
      monacoEditor: null
    }
  },
  computed: {
    editorContent() {
      return this.editor?._ready ? this.editor.getText() : ''
    }
  },
  mounted() {
    this.monacoEditor = monaco.editor.create(document.getElementById(`${this.file.code}-editor`), {
      value: this.file.content,
      language: this.file.code === "js" ? "typescript" : this.file.code,
      theme: "vs-dark",
      tabSize: 4,
      readOnly: this.readOnly
    })

    this.editor = fromMonaco(
      this.file.ref,
      this.monacoEditor,
      {
        userId: this.firebaseUid,
        userName: this.$store.getters['auth/username'],
        userColor: this.userColor,
      }
    )
  },
  watch: {
    'editorContent' (newVal) {
      if (newVal || newVal === '') {
        this.$emit('preview', {
          content: this.editorContent,
          code: this.file.code
        })
      }
    },
    'readOnly' (newVal) {
      this.monacoEditor.updateOptions({ readOnly: newVal })
    }
  }
}
</script>
